export default function DigitalEffects() {
  return (
    <section id="effects" className="relative py-32 px-8 bg-black overflow-hidden">
      {/* Background subtle texture */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-amber-950/10 to-black pointer-events-none" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[1px] bg-gradient-to-r from-transparent via-amber-500/30 to-transparent" />

      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-12 h-px bg-gradient-to-r from-transparent to-amber-400" />
            <span className="text-amber-400/80 text-xs tracking-[0.4em] font-light uppercase" style={{ fontFamily: "'Noto Sans TC', sans-serif" }}>SERVICES · CAPABILITIES</span>
            <div className="w-12 h-px bg-gradient-to-l from-transparent to-amber-400" />
          </div>
          <h2
            className="text-5xl md:text-6xl font-black leading-tight tracking-tight"
            style={{ fontFamily: "'Noto Serif TC', serif" }}
          >
            <span
              style={{
                background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 30%, #fde68a 60%, #d97706 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                filter: 'drop-shadow(0 0 30px rgba(251,191,36,0.4))',
              }}
            >
              結合 AI 技術
            </span>
            <span className="text-white"> 與 </span>
            <span
              style={{
                background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 30%, #fde68a 60%, #d97706 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                filter: 'drop-shadow(0 0 30px rgba(251,191,36,0.4))',
              }}
            >
              魔幻視效
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Left card - 動態特效設計 */}
          <div>
            <div className="relative h-80 rounded-sm overflow-hidden border border-amber-500/30 hover:border-amber-400/70 transition-all duration-500 hover:scale-[1.02] hover:shadow-2xl hover:shadow-amber-500/30 cursor-pointer group">
              <iframe
                src="https://www.youtube.com/embed/Zfwm4qgpHAY?autoplay=1&mute=1&loop=1&playlist=Zfwm4qgpHAY&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1"
                className="absolute inset-0 w-full h-full object-cover pointer-events-none"
                style={{ border: 'none', transform: 'scale(1.1)' }}
                allow="autoplay; encrypted-media"
                allowFullScreen
                title="動態特效設計"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-amber-900/20 to-black/60" />
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/95 via-black/70 to-transparent">
                <div
                  className="w-14 h-14 flex items-center justify-center rounded-sm mb-3"
                  style={{ background: 'linear-gradient(135deg, #d97706, #fbbf24)' }}
                >
                  <i className="ri-flashlight-line text-2xl text-black"></i>
                </div>
                <h3
                  className="text-2xl font-bold text-white mb-2"
                  style={{ fontFamily: "'Noto Serif TC', serif" }}
                >
                  動態特效設計
                </h3>
                <p className="text-white/60 text-sm leading-relaxed" style={{ fontFamily: "'Noto Sans TC', sans-serif" }}>
                  專業的粒子系統、光效追蹤與動態模擬，為影片增添震撼的視覺衝擊力。
                </p>
              </div>
            </div>
          </div>

          {/* Right card - 3D動畫製作 */}
          <div>
            <div className="relative h-80 rounded-sm overflow-hidden border border-amber-500/30 hover:border-amber-400/70 transition-all duration-500 hover:scale-[1.02] hover:shadow-2xl hover:shadow-amber-500/30 cursor-pointer group">
              <iframe
                src="https://www.youtube.com/embed/HpjH1ZK1JSs?autoplay=1&mute=1&loop=1&playlist=HpjH1ZK1JSs&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1"
                className="absolute inset-0 w-full h-full object-cover pointer-events-none"
                style={{ border: 'none', transform: 'scale(1.1)' }}
                allow="autoplay; encrypted-media"
                allowFullScreen
                title="3D動畫製作"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-amber-900/20 to-black/60" />
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/95 via-black/70 to-transparent">
                <div
                  className="w-14 h-14 flex items-center justify-center rounded-sm mb-3"
                  style={{ background: 'linear-gradient(135deg, #d97706, #fbbf24)' }}
                >
                  <i className="ri-box-3-line text-2xl text-black"></i>
                </div>
                <h3
                  className="text-2xl font-bold text-white mb-2"
                  style={{ fontFamily: "'Noto Serif TC', serif" }}
                >
                  3D動畫製作
                </h3>
                <p className="text-white/60 text-sm leading-relaxed" style={{ fontFamily: "'Noto Sans TC', sans-serif" }}>
                  精緻的3D建模與動畫製作，打造栩栩如生的角色與場景，呈現完美的視覺效果。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
